import { render, staticRenderFns } from "./HWP_BuildingPokaz.vue?vue&type=template&id=e1ffcc72&scoped=true&"
import script from "./HWP_BuildingPokaz.vue?vue&type=script&lang=js&"
export * from "./HWP_BuildingPokaz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ffcc72",
  null
  
)

export default component.exports